export default {"src":"/_next/static/media/nft.55e9fd71.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};